import BaseController from "confinus_ui/base_controller";
import Sortable from "sortablejs";

export default class extends BaseController {
  static targets = ["tbody", "row"];
  private sortable?: Sortable;

  connect() {
    const tbody = this.tbodyTarget;

    this.sortable = Sortable.create(tbody, {
      handle: ".drag-handle",
      animation: 150,
      ghostClass: "opacity-50",
      dragClass: "cursor-grabbing",
      onEnd: this.handleDragEnd.bind(this),
    });
  }

  disconnect() {
    if (this.sortable) {
      this.sortable.destroy();
    }
  }

  async handleDragEnd(event: Sortable.SortableEvent) {
    const row = event.item as HTMLTableRowElement;
    // Get SKU from data attribute
    const sku = row.dataset.sku;

    if (!sku) {
      console.error("Could not find SKU in row data");
      return;
    }

    if (event.newIndex === undefined) {
      console.error("New position is undefined");
      return;
    }

    const newPosition = event.newIndex + 1; // Position is 1-based

    // Collect all SKUs in their new order
    const allRows = this.tbodyTarget.querySelectorAll("tr");
    const allSkus: string[] = [];
    allRows.forEach((row) => {
      const rowSku = (row as HTMLTableRowElement).dataset.sku;
      if (rowSku) {
        allSkus.push(rowSku);
      }
    });

    // Get the reorder URL from the table's data attribute
    const reorderUrl = (this.element as HTMLElement).dataset.reorderUrl;
    if (!reorderUrl) {
      console.error("No reorder URL found");
      return;
    }

    // Build the URL with the SKU
    const url = reorderUrl.replace(":sku", encodeURIComponent(sku));

    try {
      const response = await fetch(url, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": this.csrfToken,
          Accept: "application/json",
        },
        body: JSON.stringify({
          position: newPosition,
          all_skus: allSkus,
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
    } catch (error) {
      console.error("Failed to update position:", error);
      // Revert the drag by reloading the page or resetting positions
      // For now, just reload to get the correct order
      window.location.reload();
    }
  }

  get tbodyTarget(): HTMLTableSectionElement {
    return this.element.querySelector("tbody") as HTMLTableSectionElement;
  }

  get csrfToken(): string {
    const meta = document.querySelector('meta[name="csrf-token"]');
    return meta ? meta.getAttribute("content") || "" : "";
  }
}
